/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { TABS } from "./Transactions";

/*
 * The three tabs were once three pages (CP-413). Their old paths stay
 * reachable for bookmarks, landing on the matching tab. location.state goes
 * along, since it can carry a payment to open (CP-406).
 */
const LEGACY_TABS = {
  "/donationrecord": "completed",
  "/donationrecordrecurring": "scheduled",
  "/donationrecordreauthenticate": "reauthenticate",
};

function LegacyTransactionsRedirect({ location }) {
  const legacyPath = location.pathname.replace(/\/+$/, "").toLowerCase();
  const tab = LEGACY_TABS[legacyPath] || "completed";
  return (
    <Redirect
      to={{
        pathname: TABS[tab].path,
        search: location.search,
        state: location.state,
      }}
    />
  );
}

LegacyTransactionsRedirect.propTypes = {
  location: PropTypes.object.isRequired,
};

export default LegacyTransactionsRedirect;
